<template>
  <b-container class="w-100" ref="footer" @mousemove="showButton" @mouseleave="hideButton">
    <transition :name="!showFooter ? 'fade-down' : 'fade-up'">
      <b-row class="b-c-gray pt-3" v-show="showFooter">
        <b-container>
          <b-row align-h="center" style="height: 0">
            <transition :name="showFooter ? 'fade-down' : 'fade-up'">
              <i class="my-button-footer-down hover-enabled fas fa-chevron-down c-green p-4 fa-3x"
                 v-show="showFooter && showButtons" v-on:click="checkFooter"/>
            </transition>
          </b-row>

          <b-row allign-h="center" v-on:click="showButtons = true">
            <b-col cols="12" sm="12" md="6" :lg="logged ? '4' : '6'" :xl="logged ? '4' : '6'" class="mb-4">
              <b-container>
                <b-row>
                  <b-col>
                    <h4>AWTrack</h4>
                  </b-col>
                </b-row>
              </b-container>
            </b-col>

            <b-col cols="12" sm="12" md="6" :lg="logged ? '4' : '6'" :xl="logged ? '4' : '6'" class="mb-4">
              <b-container>
                <h5 class="c-green">{{$tc('message.contact', 2)}}</h5>
                <b-row class="mt-1">
                  <b-col cols="1" sm="1" md="1" lg="1" xl="1">
                    <i class="fas fa-phone"/>
                  </b-col>
                  <b-col>
                    +39 050 0986268
                  </b-col>
                </b-row>

                <b-row class="mt-1">
                  <b-col cols="1" sm="1" md="1" lg="1" xl="1">
                    <i class="far fa-envelope"/>
                  </b-col>
                  <b-col>
                    info@awtech.it
                  </b-col>
                </b-row>

                <b-row class="mt-1">
                  <b-col cols="1" sm="1" md="1" lg="1" xl="1">
                    <i class="fas fa-external-link-alt"/>
                  </b-col>
                  <b-col>
                    <a href="https://www.awtech.it" class="c-white h-c-green">www.awtech.it</a>
                  </b-col>
                </b-row>
              </b-container>
            </b-col>

            <b-col cols="12" sm="12" md="12" lg="4" xl="4" v-if="logged" class="mb-4">
              <b-container>
                <h5 class="c-green" id="nw-navigate">{{$t('message.navigate')}}</h5>
                <b-row v-for="button in buttons" :key="button.href">
                  <b-col>
                    <router-link :to="button.href" class="mr-2 c-white h-c-blue">{{button.title}}<i
                      class="fas fa-angle-right ml-1"/></router-link>
                  </b-col>
                </b-row>
              </b-container>
            </b-col>
          </b-row>
        </b-container>
      </b-row>
    </transition>

    <b-row class="b-c-black">
      <b-container class="mw-100 m-2">
        <b-row align-h="center" style="height: 0">
          <transition :name="showFooter ? 'fade-down' : 'fade-up'">
            <i class="my-button-footer-up hover-enabled fas fa-chevron-up c-green p-4 fa-3x"
               v-show="!showFooter && showButtons" v-on:click="checkFooter"/>
          </transition>
        </b-row>
        <b-row align-h="center" v-on:click="showButtons = true" v-if="!isMobile">
          <b-col cols="12" sm="12" md="2" lg="3" xl="4">
            <changeLanguage>

            </changeLanguage>
          </b-col>

          <b-col>
            <b-container>
              <b-row align-h="center" align-v="center">
                Copyright © Geoin & AWTech - Gestione flotte
              </b-row>
            </b-container>
          </b-col>

          <b-col cols="12" sm="12" md="2" lg="3" xl="4">
            <i class="fas fa-arrow-alt-circle-up fa-2x float-right hover-enabled mt-1" v-if="hasScrollbar"
               v-on:click="gotToTop"/>
          </b-col>
        </b-row>
        <b-row align-h="center" v-on:click="showButtons = true" v-if="isMobile">
          <b-col cols="auto" sm="auto" md="auto">
            <changeLanguage>

            </changeLanguage>
          </b-col>
          <b-col cols="12" sm="10" md="4">
            <div>
              Copyright © Geoin & AWTech
            </div>
            <div>
              Gestione flotte
            </div>
          </b-col>

          <b-col cols="2" sm="2" md="4" v-if="!isMD">
            <i class="fas fa-arrow-alt-circle-up fa-2x float-right hover-enabled mt-1" v-if="hasScrollbar"
               v-on:click="gotToTop"/>
          </b-col>

          <b-col cols="2" sm="2" md="4" v-if="isMD">
            <i class="fas fa-arrow-alt-circle-up fa-2x float-right hover-enabled mt-1" v-if="hasScrollbar"
               v-on:click="gotToTop"/>
          </b-col>
        </b-row>
      </b-container>
    </b-row>
  </b-container>
</template>

<script>
import Vue from 'vue'
import routeViews from '../router-views'
import changeLanguage from '../components/vue-plugins/ChangeLanguage'

export default {
  name: 'Footer',
  components: {
    changeLanguage
  },
  mounted () {
    this.$root.$on('change-lang', () => {
      this.getButtons(this)
    })
    this.$root.$on('resize', (size) => {
      this.checkSize(size)
    })
    this.$nextTick(() => {
      window.onscroll = () => this.handleScroll()
    })

    this.handleScroll()
    this.checkSize(Vue.myGetWindowSize())
    this.getButtons(this)
  },
  beforeDestroy () {
    window.onscroll = null
  },
  watch: {
    '$route' (to) {
      const session = Vue.getLocalStorage('session')
      const showFooter = Vue.getLocalStorage('showFooter')
      this.logged = !!(session && session.token)
      if (to.path === '/home') {
        this.showFooter = false
      } else {
        this.showFooter = showFooter
      }
    }
  },
  data () {
    const hasScrollbar = window.scrollY > 0
    const session = Vue.getLocalStorage('session')
    const showFooter = Vue.getLocalStorage('showFooter')
    return {
      hasScrollbar,
      buttons: [],
      isMD: false,
      isMobile: true,
      showFooter: showFooter,
      showButtons: false,
      logged: !!(session && session.token)
    }
  },
  methods: {
    handleScroll () {
      this.hasScrollbar = window.scrollY > 0
    },
    gotToTop () {
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
      this.$nextTick(() => {
        this.showButtons = false
      })
    },
    showButton () {
      this.showButtons = true
    },
    hideButton () {
      this.showButtons = false
    },
    checkFooter () {
      this.showFooter = !this.showFooter
      if (this.isMobile) {
        this.showButtons = false
      }
      Vue.setLocalStorage('showFooter', this.showFooter)
      this.$nextTick(() => {
        if (this.showFooter) {
          window.scrollTo(0, document.body.scrollHeight)
        }
      })
    },
    getButtons (it) {
      let routes = Vue.getLocalStorage('routes')
      routes = routes ? JSON.parse(atob(routes)) : null
      const buttons = routeViews.footerButtons(this, routes)
      const editedButtons = []
      if (buttons && buttons.length !== 0) {
        buttons.forEach((button) => {
          let name = ''
          if (button.title && Array.isArray(button.title)) {
            button.title.forEach((nameChunk, index) => {
              if (it) {
                if (!isNaN(nameChunk.num) && index === 0) {
                  name += `${it.$tc(nameChunk.option, nameChunk.num)} `
                } else if (!isNaN(nameChunk.num) && index !== 0) {
                  name += `${it.$tc(nameChunk.option, nameChunk.num).toLowerCase()} `
                } else if ((nameChunk.num === null || nameChunk.num === undefined) && index !== 0) {
                  name += `${it.$t(nameChunk.option).toLowerCase()} `
                } else {
                  name += `${it.$t(nameChunk.option)} `
                }
              }
            })
          } else {
            name = button.title
          }
          editedButtons.push({ href: button.href, title: name })
        })
      }
      this.buttons = editedButtons
    },
    checkSize (size) {
      this.isMD = size === 'md'
      this.isMobile = size !== 'lg' && size !== 'xl'
    }
  }
}
</script>

<style scoped>
.w-100 {
  max-width: 100% !important;
}
.fade-down-enter-active {
  transition: all .5s ease;
}
.fade-down-leave-active {
  transition: all .5s
}
.fade-down-enter {
  transform: translateY(-30px);
  opacity: 0;
}
.fade-down-leave-to {
  transform: translateY(30px);
  opacity: 0;
}

.fade-up-enter-active {
  transition: all .5s ease;
}
.fade-up-leave-active {
  transition: all .5s revert;
}
.fade-up-enter {
  transform: translateY(30px);
  opacity: 0;
}
.fade-up-leave-to {
  transform: translateY(-30px);
  opacity: 0;
}

.my-button-footer-down {
  position: relative;
  bottom: 100px;
}

.my-button-footer-up {
  position: relative;
  bottom: 95px;
}
</style>
